import { CheckCircleIcon } from "@heroicons/react/24/solid"
import { Oval } from "react-loader-spinner"
import { twMerge } from "tailwind-merge"

interface LoadingStepProps {
  label: string
  isComplete: boolean
}

export default function LoadingStep({ label, isComplete }: LoadingStepProps) {
  return (
    <div className="flex items-center justify-center gap-2">
      <h2
        className={twMerge(
          "text-base",
          isComplete ? "text-text-primary" : "text-text-secondary",
        )}
      >
        {label}
      </h2>
      {isComplete ? (
        <CheckCircleIcon className="theme-bullet-point h-6 w-6 shrink-0" />
      ) : (
        <Oval
          color="white"
          secondaryColor="gray"
          height={20}
          width={20}
          strokeWidth={5}
          strokeWidthSecondary={5}
        />
      )}
    </div>
  )
}
